export default "__VITE_ASSET__D97ioGH2__"